import {HttpClient} from "../../service/httpClient/HttpClient";
import {LanguageHelper} from "../../util/LanguageHelper";

export class ResidencesManagerService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getResidencesManagerList(page, size) {
        return this.httpClient.get(
            `clerks`, {
                page,
                size,
                "language-code": LanguageHelper.getLanguageCode(),
            }
        )
    }

    addNewClerk(name, phoneNumber, userName) {

        let formData = new URLSearchParams()

        formData.append("fullName", name)
        formData.append("username", userName)
        formData.append("phoneNumber", phoneNumber)

        return new Promise((resolve, reject) => {
                new HttpClient(
                    {},
                    'application/x-www-form-urlencoded'
                ).post(
                    `clerks`,
                    formData,
                    {},
                    {
                        "language-code": LanguageHelper.getLanguageCode(),
                    }
                ).then(resolve).catch(reject)
            }
        )

    }

    getClerkInfo(id, languageCode) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `clerks/${id}/information`,
                {
                    "language-code": languageCode
                }
            ).then(resolve).catch(reject)
        })
    }

    updateClerkInfo(id, languageCode, fullName, phoneNumber) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `clerks/${id}/information`,
                {
                    "metaData": {
                        "fullName": fullName
                    },
                    "phoneNumber": phoneNumber
                },
                {},
                {
                    "language-code": languageCode
                }
            ).then(resolve).catch(reject)
        })
    }

    updateManagerUserNameById(clerkId, newUsername) {

        let formData = new URLSearchParams()
        formData.append("newUsername", newUsername)

        return new Promise((resolve, reject) => {
            new HttpClient(
                {},
                "application/x-www-form-urlencoded"
            ).patch(
                `clerks/${clerkId}/username`,
                {},
                formData
            ).then(resolve).catch(reject)
        })
    }

    changeManagerPasswordById(clerkId, newPassword) {

        let formData = new URLSearchParams()
        formData.append("newPassword", newPassword)

        return new Promise((resolve, reject) => {
            new HttpClient({}, "application/x-www-form-urlencoded").patch(
                `clerks/${clerkId}/password`,
                {},
                formData
            ).then(resolve).catch(reject)
        })
    }

    getManagerEnabled(clerkId) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `clerks/${clerkId}/enabled`
            ).then(resolve).catch(reject)
        })
    }

    changeManagerEnabledState(clerkId, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `clerks/${clerkId}/enabled`,
                {},
                {
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }
}